"use client";

/**
 * InputStation — the surface at the bottom of the task page: the composer.
 *
 * It used to switch modes: when the task waited on you it swapped the
 * composer for the ask (a permission, a question, a connect…), with a pill to
 * swipe back and a "+N more" hint for queued siblings. That deck is gone for
 * good (founder 09-02, "gone forever"): every ask is now a card in the story
 * column, just under "Bash is waiting for you" (task-story/TurnAsks), and this
 * surface is only ever the composer. Subagent-lane pauses keep their inline
 * cards inside the delegation lanes; nothing about them changes here.
 *
 * See docs/superpowers/specs/2026-04-20-input-station.md for the mode-switch
 * era; it no longer describes this file.
 */

import { memo } from "react";
import { MessageInput, type MessageInputProps } from "./MessageInput";

function InputStationImpl(props: MessageInputProps) {
  return (
    <div className="[&_.input-station\_\_frame]:border-0 [&_.input-station\_\_frame]:bg-transparent">
      {/* Above-input peek: the collapsible todo progress card. Self-hides when
          the current task has no todos. On the task screen V2 the float's
          Progress section owns the plan, so the peek stays away. */}
      <div className="input-station__content input-station__content--text">
        <MessageInput {...props} />
      </div>
    </div>
  );
}

// Export the MEMOIZED component as the canonical `InputStation` (both named and
// default). Callers — including the task layout and the message-input barrel —
// import the named export, so the memo must live on the name everyone uses, not
// only on the default. With stable props (see task/layout callbacks), the
// composer subtree no longer re-renders on unrelated layout updates.
export const InputStation = memo(InputStationImpl);
InputStation.displayName = "InputStation";
export default InputStation;
